import angular from 'angular'
import { Subject } from 'rx'

class EfLockScreenService {
  constructor() {
    this.isShowing = false
    this.onShowNotifier = new Subject()
    this.onHideNotifier = new Subject()

    this.resolvers = []
  }

  show(usuario) {
    return new Promise((resolve, reject) => {
      this.onShowNotifier.onNext(usuario)
      this.resolvers.push({ resolve, reject })
    })
  }

  hide() {
    this.resolvers.forEach(({ resolve }) => resolve())
    this.resolvers = []
    this.onHideNotifier.onNext()
  }

  onShow(fun) {
    return this.onShowNotifier.subscribe(fun)
  }

  onHide(fun) {
    return this.onHideNotifier.subscribe(fun)
  }
}

class EfLockScreen {
  static get $inject() {
    return ['$scope', 'promiseTracker', 'tempService', 'UsuariosService', 'EfLockScreenService']
  }

  constructor($scope, promiseTracker, tempService, UsuariosService, EfLockScreenService) {
    this.apply = fun => $scope.$applyAsync(fun)

    this.error = false
    this.submitTracker = promiseTracker()
    this.tempService = tempService
    this.UsuariosService = UsuariosService
    this.EfLockScreenService = EfLockScreenService
  }

  $onInit() {
    this.EfLockScreenService.onShow(usuario => {
      this.apply(() => {
        this.usuario = usuario
        this.isShowing = true
      })
    })

    this.EfLockScreenService.onHide(() => {
      this.apply(() => {
        this.isShowing = false
        this.usuario = null
      })
    })
  }

  clicar() {
    const requests = this.tempService.get('blockedRequests') || []
    this.tempService.store('blockedRequests', [], true)

    this.submitTracker.addPromise(
      this.UsuariosService
        .login(this.usuario.email, this.password)
        .then(() => this.EfLockScreenService.hide())
        .catch(() => {
          this.tempService.store('blockedRequests', requests, true)
          this.error = true
        })
        .finally(() => this.apply())
    )
  }
}

angular.module('eficienciaFiscalModule').service('EfLockScreenService', EfLockScreenService)

angular.module('eficienciaFiscalModule').component('efLockScreen', {
  controller: EfLockScreen,
  template: `
  <div ng-if="$ctrl.isShowing" class="lockscreen">

    <div class="lockscreen__container animated flipInY">
      <i class="fa fa-user" aria-hidden="true"></i>

      <form ng-submit="$ctrl.clicar()">
        <h1>{{ $ctrl.usuario.nome }}</h1>

        <span>
          <i class="fa fa-lock text-muted"></i> Bloqueado
        </span>

        <p class="text-muted">
          <a href="mailto:{{$ctrl.usuario.email}}">{{ $ctrl.usuario.email }}</a>
        </p>

        <p class="text-danger" ng-show="$ctrl.error">Senha inválida, tente novamente.</p>

        <div class="input-group">
          <input class="form-control" type="password" ng-model="$ctrl.password" placeholder="Senha" required>
            <div class="input-group-btn">
              <button type="submit" ng-disabled="$ctrl.submitTracker.active()" class="btn btn-primary">
                <i ng-hide="$ctrl.submitTracker.active()" class="fa fa-key"></i>
                <i ng-show="$ctrl.submitTracker.active()" class="fa fa-circle-o-notch fa-spin"></i>
              </button>
            </div>
        </div>
        <p class="no-margin margin-top-5">
          Deseja entrar com outro usuário? <a href="/logout"> Clique aqui.</a>
        </p>
      </form>
    </div>
  </div>
  `
});
